@if (isMobile) {
    <div class="content flex flex-col mobile" slot="content">
        <div style="min-height: calc(100% + 40px);">
            <router-outlet></router-outlet>
        </div>
    </div>
} @else {
    <enelx-navbar [productName]="'Flex'" url="{{ navBarUrl }}" position="left" [maxMenuElements]="0">
        <div class="content flex flex-col" slot="content">
            <div class="web-header">
                <h3>{{ 'APP.TITLE' | translate }}</h3>
            </div>
            <div class="nav-tabs active-dispatch-nav-tabs" data-qaa="dispatch-schedule-tab">
                <div class="nav-tab" *ngIf="locale=='en-us'">
                    <a [routerLink]="[getRoutePrefix() + '/schedule']" routerLinkActive="active">{{ 'TABS.DISPATCH_SCHEDULE' | translate }}</a>
                </div>
                <div class="nav-tab" data-qaa="dispatch-performance-tab">
                    <a [routerLink]="[getRoutePrefix() + '/performance']" routerLinkActive="active">{{ 'TABS.DISPATCH_PERFORMANCE' | translate }}</a>
                </div>
            </div>
            <div style="min-height: calc(100% + 40px);">
                <router-outlet></router-outlet>
                <ngx-global-contact-footer class="footer"></ngx-global-contact-footer>
            </div>
        </div>
    </enelx-navbar>
}